export default __webpack_public_path__ + "static/media/overview_yqhy_en.5b9d71a3.png";